import { Container, useMediaQuery } from '@mui/material';
import FrontChat from 'components/FrontChat';
import { Header } from 'components/Header';
import { QuoteStepperWithContextWrapper } from 'components/QuoteStepper';
import theme from 'providers/theme/theme';
import type { FC, ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  renderStepper?: boolean;
  displayQuoteNumber?: boolean;
  displaySaveAndExit?: boolean;
  displayChatWidget?: boolean;
  verticalCentered?: boolean;
  extendContainer?: boolean;
}

const DefaultLayout: FC<IProps> = ({
  children,
  renderStepper = true,
  displayQuoteNumber = false,
  displaySaveAndExit = false,
  displayChatWidget = false,
  verticalCentered = false,
  extendContainer = false,
}) => {
  const isTabletLayout = useMediaQuery(theme.breakpoints.down('md'));

  // calculate proper Header height to prevent overlaying other elements when QuoteNumber takes new line for smaller screens
  // where value 1.5rem its the size of QuoteNumber paddingY + QuoteNumber_Number paddingY
  const appBarHeightWithQuoteNumber =
    isTabletLayout && displayQuoteNumber
      ? `calc(${theme.customStyling.appBar.height} + ${theme.typography.body1.fontSize} + 1.5rem)`
      : theme.customStyling.appBar.height;

  return (
    <>
      <Header
        displayQuoteNumber={displayQuoteNumber}
        displaySaveAndExit={displaySaveAndExit}
        displayChatWidget={displayChatWidget}
        sx={{ minHeight: appBarHeightWithQuoteNumber }}
      />

      {displayChatWidget && <FrontChat />}

      <Container
        maxWidth="sm"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: `calc(100dvh - ${appBarHeightWithQuoteNumber})`,
          p: 3,
          ...(verticalCentered
            ? {
                alignItems: 'center',
                justifyContent: 'center',
              }
            : {
                mt: appBarHeightWithQuoteNumber,
                alignItems: 'stretch',
              }),
          ...(extendContainer && {
            maxWidth: '720px !important',
          }),
        }}
      >
        {renderStepper && <QuoteStepperWithContextWrapper />}

        {children}
      </Container>
    </>
  );
};

export default DefaultLayout;
